import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { GroupsService } from '../../services/groups.service';
import { ShareCardsService } from '../../services/share-cards.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-group-detail',
  templateUrl: './group-detail.component.html',
  styleUrls: ['./group-detail.component.scss'],
  standalone: false,
})
export class GroupDetailComponent implements OnInit {
  group: any;
  standings: any[] = [];
  weeklyPodium: any[] = [];
  stats: any;
  posts: any[] = [];
  message = '';
  loading = true;
  saving = false;
  isAdmin = false;
  loggedUser: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private groupsService: GroupsService,
    private authService: AuthService,
    private snackbar: SnackbarService,
    private shareCards: ShareCardsService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.loggedUser = this.authService.getUser();
    this.isAdmin = this.authService.isAdmin();
    await this.load();
  }

  goBack(): void {
    this.router.navigate(['/home']);
  }

  async publish(): Promise<void> {
    const message = this.message.trim();
    if (!message || this.saving) return;
    this.saving = true;
    try {
      const post = await this.groupsService.createPost(this.group._id, message);
      this.posts.unshift(post);
      this.message = '';
    } catch (error: any) {
      this.snackbar.error(error?.message || 'No se pudo publicar el mensaje.');
    } finally {
      this.saving = false;
    }
  }

  async saveIdentity(): Promise<void> {
    this.saving = true;
    try {
      this.group = await this.groupsService.update(this.group);
      this.snackbar.success('Identidad del grupo actualizada.');
    } catch (error: any) {
      this.snackbar.error(error?.message || 'No se pudo actualizar el grupo.');
    } finally {
      this.saving = false;
    }
  }

  shareMyPosition(): void {
    const index = this.standings.findIndex(
      (entry) => entry.user?._id === this.loggedUser?._id,
    );
    if (index < 0) return;
    void this.shareCards.shareGroupPosition({
      groupName: this.group.name,
      userName: this.loggedUser.name,
      position: index + 1,
      points: this.standings[index].points ?? 0,
    });
  }

  isShieldImage(value: string | undefined): boolean {
    return /^https?:\/\//i.test(value ?? '');
  }

  private async load(): Promise<void> {
    this.loading = true;
    try {
      const data: any = await this.groupsService.get(
        this.route.snapshot.params['id'],
      );
      this.group = data.group;
      this.standings = data.standings ?? [];
      this.weeklyPodium = data.weeklyPodium ?? [];
      this.stats = data.stats ?? {};
      this.posts = data.posts ?? [];
    } catch (error: any) {
      this.snackbar.error(error?.message || 'No se pudo cargar el grupo.');
      this.goBack();
    } finally {
      this.loading = false;
    }
  }
}
